// Presentation only: callers keep their original IDs for selection, storage and API requests.
let maps = { regiones: {}, areas: {}, centros: {} };
let version = 0;
const listeners = new Set();
export const subscribeLabels = (listener) => { listeners.add(listener); return () => listeners.delete(listener); };
export const labelsVersion = () => version;
export function setLabels(next) {
  maps = { regiones: next?.regiones || {}, areas: next?.areas || {}, centros: next?.centros || {} };
  version += 1;
  listeners.forEach((listener) => listener());
}

export const labelKey = (value) => typeof value === 'string'
  ? value.split('-').map((p) => p.normalize('NFC').trim().replace(/^"+|"+$/g, '').replace(/\s/g, '').toLowerCase()).join('-')
  : '';
const resolve = (type, key, fallback) => {
  const value = maps[type][labelKey(key)];
  return typeof value === 'string' && value ? value : fallback;
};
export const labelRegion = (region, fallback = region) => resolve('regiones', region, fallback);
export const labelArea = ({ region, area } = {}, fallback) => region && area ? resolve('areas', `${region}-${area}`, fallback) : fallback;
export const labelCentro = ({ region, area, centro } = {}, fallback) => region && area && centro
  ? resolve('centros', `${centro}-${area}-${region}`, fallback) : fallback;

export function partesDeId(id, formato) {
  if (typeof id !== 'string' || !['car', 'rac', 'ra', 'ar'].includes(formato)) return null;
  const parts = id.split('-');
  if (parts.length !== formato.length || parts.some((p) => !p.trim())) return null;
  const fields = { c: 'centro', a: 'area', r: 'region' };
  return Object.fromEntries([...formato].map((letter, index) => [fields[letter], parts[index]]));
}
export function labelId(id, formato, fallback = id) {
  const parts = partesDeId(id, formato);
  return !parts ? fallback : parts.centro ? labelCentro(parts, fallback) : labelArea(parts, fallback);
}

export async function labelsRequest(server, path, options = {}) {
  const response = await fetch(`${server}${path}`, {
    credentials: 'include', ...options,
    headers: { 'Content-Type': 'application/json', ...options.headers },
  });
  const data = await response.json().catch(() => null);
  if (!response.ok || data === null) {
    const error = new Error(data?.codigo || 'labels_request_failed');
    error.status = response.status;
    throw error;
  }
  return data;
}
export const guardarEtiqueta = (server, tipo, slug, label) => labelsRequest(server, '/etiquetas', {
  method: 'PUT', body: JSON.stringify({ tipo, slug, label }),
});
